
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    fields: {
      type: Array,
      required: true,
      default() {
        return []
      }
    },
    name: {
      type: String,
      required: true,
      default: ''
    },
    humanName: {
      type: String,
      required: true,
      default: ''
    },
    extras: {
      type: Object,
      required: false,
      default() {
        return {}
      }
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    }
  }
})
